import { render, staticRenderFns } from "./AutocompleteBasicWithEmits.vue?vue&type=template&id=a5c6d626"
import script from "./AutocompleteBasicWithEmits.vue?vue&type=script&lang=js"
export * from "./AutocompleteBasicWithEmits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports